import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	teamPreviewLabel: {
		id: 'issue-field-team-readview-with-gpp.team.preview-label',
		defaultMessage: 'Click to view {teamName} team details',
		description:
			'Aria Label for the clickable team name that opens the team preview panel - Click to view [team name] team details',
	},
});
